module.exports = __webpack_public_path__ + "img/gone.ed66254e.jpg";